import { render, staticRenderFns } from "./CheckBox.vue?vue&type=template&id=1c17a45f&"
import script from "./CheckBox.vue?vue&type=script&scoped=true&lang=js&"
export * from "./CheckBox.vue?vue&type=script&scoped=true&lang=js&"


/* normalize component */
import normalizer from "!../../../NodeModules/Ljbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports